module.exports = __webpack_public_path__ + "fonts/GothamNarrow-Ultra.e7fd253c.otf";